  // https://icons.getbootstrap.com/icons/play-circle-fill/

export default function PlayButtonIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="128"
      height="128"
      fill="#1ed760" // spotify-green-2
      className="bi bi-play-circle-fill"
      viewBox="0 0 16 16"
      aria-label="play button image"
    >
      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814z" />
    </svg>
  );
}
